import React from "react";
import { Route } from "react-router-dom";

export default ({ component: C, props: cProps,detail: dProps, ...rest }) =>
  <Route {...rest} render={props => <C {...props} {...cProps} isAuthenticated={dProps}/>} />;
